const awsconfig = {
    aws_appsync_region: 'us-east-2',
    aws_appsync_graphqlEndpoint:
        'https://jzxvh5xtfrcp3afome2rmmjdda.appsync-api.us-east-2.amazonaws.com/graphql',
    aws_appsync_authenticationType: 'API_KEY',
    aws_appsync_apiKey: 'da2-xkqinbpw25dyjewdusgz626cbe',
};

export default awsconfig;
